export var AuthEventKind;
(function (AuthEventKind) {
    AuthEventKind[AuthEventKind["ActiveUserChanged"] = 0] = "ActiveUserChanged";
    AuthEventKind[AuthEventKind["ListenerRegistered"] = 1] = "ListenerRegistered";
    AuthEventKind[AuthEventKind["UserAdded"] = 2] = "UserAdded";
    AuthEventKind[AuthEventKind["UserLinked"] = 3] = "UserLinked";
    AuthEventKind[AuthEventKind["UserLoggedIn"] = 4] = "UserLoggedIn";
    AuthEventKind[AuthEventKind["UserLoggedOut"] = 5] = "UserLoggedOut";
    AuthEventKind[AuthEventKind["UserRemoved"] = 6] = "UserRemoved";
})(AuthEventKind || (AuthEventKind = {}));
//# sourceMappingURL=AuthEvent.js.map